<template>
   <v-col md="12" style="height: 100%;" class="pt-0 mt-0">  
    <v-row justify="center" align="center" style=" max-width: 700px; margin: 0 auto; height: 100%" class="pt-0">
      <v-col style="background-color: whitesmoke; min-height: 480px; max-width: 355px" class="elevation-4">
        <v-row justify="center" class="pb-3">
          <h1>Crear Cuenta</h1>
        </v-row>
        <v-row style="width: 90%; margin: 0 auto;">
          <v-text-field v-model="name" dense label="Nombre Completo" single-line solo></v-text-field>
          <v-text-field v-model="bdate" dense label="Fecha de nacimiento" single-line solo></v-text-field>
          <v-text-field v-model="phone" dense label="Teléfono" single-line solo></v-text-field>
          <div class="form-group">
            <label for="masculino">
              <input
                type="radio"
                id="masculino"
                value="M"
                v-model="gender"> Masculino
            </label>
            <label for="femenino">
              <input
                type="radio"
                id="femenino"
                value="F"
                v-model="gender"> Femenino
            </label>
          </div>
          <br><br>
          <v-text-field v-model="mail" dense label="Email" :rules="[rules.email]" single-line solo class="my-0 py-0"></v-text-field>
        </v-row>
        <v-row style="width: 90%; margin: 0 auto;">
            <v-text-field
              v-model="password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="showPassword ? 'text' : 'password'"
              name="input-10-1"
              label="Contraseña"
              counter
              @click:append="showPassword = !showPassword"
            ></v-text-field>
        </v-row>
        <v-row style="width: 90%; margin: 0 auto">
            <v-text-field
              v-model="confirmpassword"
              :append-icon="confirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.equals]"
              :type="confirmPassword ? 'text' : 'password'"
              name="input-10-1"
              label="Confirmar Contraseña"
              counter
              @click:append="confirmPassword = !confirmPassword"
            ></v-text-field>
        </v-row>
        
        <v-row justify="center" align="center" style="margin: 0 auto; font-size: 13px;" class="pt-2">
          <input type="checkbox" id="term" name="term" value="accepted">
              <span class="pl-2">Estoy de acuerdo con los Términos y Condiciones</span>
        </v-row>

          <v-row justify="center" style="margin: 0 auto" class="pt-4">
            <v-btn @click="onSubmit();" class="buttonLower" color="black" style="color: white">Registrar</v-btn>
          </v-row>

      </v-col>
    </v-row>
  </v-col>
</template>

<script>
// import axios from 'axios';
export default {
    data()
    {
        return {
            name: '',
            lastName: '',
            password: '',
            mail: '',
            bdate: '',
            phone: '',
            gender: 'M',
            confirmPassword: '',
            showPassword: false,
            showConfirm: false,
            emailPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            rules: 
            {
                min: v => v ? (v.length >= 5 || "Mínimo 5 caractéres") : true,
                equals: c => c ? (c == this.password || 'Las contraseñas no coinciden') : true,
                email: value => {
                    return value ? (this.emailPattern.test(value) || 'Correo no válido') : true
                }
            }
        }
    },
    methods:{
      onSubmit () {
        
        // const formData = {
        //   nombre: this.name,
        //   correo: this.mail,
        //   pass: this.password,
        //   fecha_nac: this.bdate,
        //   genero: this.gender,
        //   telefono: this.phone
        // }
        var username = 'swyt1';
        var password = 'r3stoDirec0.y';
        var basicAuth = 'Basic ' + btoa(username + ':' + password);
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': basicAuth,
        }
        this.$store.dispatch('signup',{
          nombre: this.name,
          correo: this.mail,
          pass: this.password,
          fecha_nac: this.bdate,
          genero: this.gender,
          telefono: this.phone,
          headers: headers
        });
        // axios.post(
        //   '/altaC',
        //   formData, 
        //   {headers: headers}
        // ).then(res =>{
        //     console.log(res)
        //     if(res.data.error != '')
        //       {
        //         alert("USUARIO EXISTENTE");
        //       }
        //       else
        //       {
        //         this.$router.push({ name: 'menu'});
        //       }
        //     // $router.push({ name: 'payment'});
        //   }) 
        //   .catch(error => console.log(error));
      }
    }
}
</script>